import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CamposCustomizablesService, IOpcionSaveRequest } from '../../services/campos-customizables.service';

@Component({
  selector: 'app-agregar-opcion-form',
  templateUrl: './agregar-opcion-form.component.html',
  providers: [MessageService]
})
export class AgregarOpcionFormComponent implements OnInit {
  @Input() opcion: string = '';
  @Input() campoPadre: string = ''; // Nombre del campo padre
  @Output() onSave = new EventEmitter<{ success: boolean; message: string }>();
  form!: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private camposCustomizablesService: CamposCustomizablesService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.form = this.fb.group({
      opcion: [this.opcion, [Validators.required, Validators.minLength(2)]]
    });
  }

  guardar(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor ingrese una opción válida'
      });
      return;
    }

    if (!this.campoPadre) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo identificar el campo padre'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    
    const payload: IOpcionSaveRequest = {
      iAccion: 1, // Crear
      sCampo: this.campoPadre,
      sOpcion: formData.opcion
    };

    this.camposCustomizablesService.saveOpcion(payload).subscribe({
      next: (response) => {
        // Verificar si el error es "0" (éxito) independientemente del success
        const errorCode = response.data?.[0]?.error;
        if (errorCode === "0") {
          this.onSave.emit({
            success: true,
            message: 'Nueva opción agregada correctamente'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: errorCode || 'Error al agregar la opción'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al agregar la opción'
        });
        this.loading = false;
      }
    });
  }

  cancelar(): void {
    this.onSave.emit({
      success: false,
      message: ''
    });
  }
} 